import { useQuery } from "@tanstack/react-query";

import { Service } from "../../types/service.type";

import { GO_SERVICE_QUERY_KEYS } from "../queryKeys";
import { getServiceById } from "../services/goHireService";

export const useGetService = (serviceId: number) => {
  return useQuery<Service>({
    queryKey: [...GO_SERVICE_QUERY_KEYS.service(serviceId), { serviceId: serviceId }],
    queryFn: async () => getServiceById(serviceId),
    enabled: !!serviceId,
  });
};
